import React from 'react'
import PropTypes from 'prop-types'
import FlexRow from '../../../../components/molecules/FlexRow'
import AttachmentPreview from './AttachmentPreview'

function AttachmentPreviewList ({ attachments, onRemove, onRetry, disabled }) {
  if (!attachments || attachments.length === 0) {
    return null
  }

  return (
    <FlexRow className='flex-wrap gap-md'>
      {attachments.map((attachment, index) => (
        <AttachmentPreview
          key={attachment.id}
          attachment={attachment}
          onRemove={() => onRemove(index)}
          onRetry={onRetry ? () => onRetry(index) : null}
          disabled={disabled}
        />
      ))}
    </FlexRow>
  )
}

AttachmentPreviewList.propTypes = {
  attachments: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      file: PropTypes.instanceOf(File),
      status: PropTypes.oneOf(['uploading', 'uploaded', 'error']).isRequired,
      fileName: PropTypes.string.isRequired,
      contentType: PropTypes.string,
      s3Key: PropTypes.string,
      textContent: PropTypes.string
    })
  ).isRequired,
  onRemove: PropTypes.func.isRequired,
  onRetry: PropTypes.func,
  disabled: PropTypes.bool
}

AttachmentPreviewList.defaultProps = {
  disabled: false,
  onRetry: null
}

export default AttachmentPreviewList
